import React, { useEffect, useState } from "react";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa";

const WhatsAppFloatingButton = () => {
  const [showButton, setShowButton] = useState(false);

  const phoneNumber = "919274764365";
  const prefilledMessage =
    "Hello, I would like to know more about your Neev Organic Haat products.";

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowButton(true);
    }, 3000); // Show after 3 seconds
    return () => clearTimeout(timer);
  }, []);

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    prefilledMessage
  )}`;
  const telUrl = `tel:+${phoneNumber}`;

  return (
    showButton && (
      <div
        className="position-fixed d-flex flex-column gap-3 z-3 pointer-events-none"
        style={{
          bottom: "120px",
          right: "12px",
        }}
      >
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-success rounded-circle d-flex align-items-center justify-content-center shadow hover:bg-success pointer-events-auto"
          style={{ width: "52px", height: "52px" }}
          title="Chat on WhatsApp"
        >
          <FaWhatsapp size={28} />
        </a>

        <a
          href={telUrl}
          className="btn btn-primary rounded-circle d-flex align-items-center justify-content-center border-1 shadow hover:bg-primary pointer-events-auto"
          style={{ width: "52px", height: "52px" }}
          title="Call Us"
        >
          <FaPhoneAlt size={20} />
        </a>
      </div>
    )
  );
};

export default WhatsAppFloatingButton;
